import $ from 'jquery';
import debounce from './utils/debounce';

class Tiles {
    constructor ($tiles) {
        this.$tiles = $tiles;

        $(window).on('load resize', debounce((e) => {
            this.tilesInRows = {};

            if (e.type === 'resize') {
                this.$tiles.css('height', 'auto');
            }

            this.sortTilesIntoRows().matchRowHeights();
        }, 300));
    }

    sortTilesIntoRows () {
        for (let i = 0; i < this.$tiles.length; i += 1) {
            const $tile = $(this.$tiles[i]);

            if ($tile.hasClass('js-match-height')) {
                if (this.tilesInRows.hasOwnProperty($tile.offset().top)) {
                    this.tilesInRows[$tile.offset().top].push($tile);
                } else {
                    this.tilesInRows[$tile.offset().top] = [$tile];
                }
            }
        }

        return this;
    }

    matchRowHeights () {
        Object.keys(this.tilesInRows).forEach((key) => {
            if (this.tilesInRows.hasOwnProperty(key) && this.tilesInRows[key].length) {
                const row = this.tilesInRows[key];

                Tiles.expandMatchHeight(row);
            }
        });
    }

    static expandMatchHeight (tiles) {
        const maxHeight = tiles.reduce((a, b) => {
            const aHeight = typeof a === 'number' ? a : a.outerHeight();
            const bHeight = typeof b === 'number' ? b : b.outerHeight();

            return aHeight > bHeight ? aHeight : bHeight;
        });

        tiles.forEach(($elem) => {
            const currHeight = $elem.outerHeight();

            if (currHeight < maxHeight) {
                $elem.css({
                    'min-height' : 0,
                    'height'     : `${$elem.outerHeight() + (maxHeight - currHeight)}px`,
                });
            }
        });
    }
}

export default Tiles;

